<span class="line-clamp-3 break-after-all font-semibold">
  {{ processedValue() }}
</span>
